import { cn } from '@/lib/utils';
import { CustomLayoutIconProps } from '../types';

export function CustomLayoutIcon({
    component: Component,
    className,
    ...iconProps
}: CustomLayoutIconProps) {
    return (
        <Component
            // fill='sidebar-foreground'
            className={cn(
                'min-h-4 min-w-4',
                // 'h-4 w-4 transition-all group-hover:scale-110',
                // fill-sidebar-foreground
                className
            )}
            {...iconProps}
        />
    );
}
